module.exports = __webpack_public_path__ + "static/cover.31e0621f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSection/videos/cover.webm
// module id = 397
// module chunks = 221374088121123